export default __webpack_public_path__ + "static/media/designEnterprise.6254f6a8.webp";